import moment from 'moment-jalaali'

import { lang } from '../../localization'

const convertDate = (date: string) => {
  const m = moment(date)
  if (lang === 'fa') {
    const year = m.format('jYYYY')
    const month = m.format('jMMMM')
    const day = m.format('jDD')
    return { year, month, day }
  }

  const year = m.format('YYYY')
  const month = m.format('MMMM')
  const day = m.format('DD')
  return { year, month, day }
}
export default convertDate
